import SideMenu from "../Components/SideMenu/SideMenu";
import React, { useEffect, useState } from "react";
import Box from "@mui/material/Box";
import CssBaseline from "@mui/material/CssBaseline";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import Drawer from "@mui/material/Drawer";
import MenuIcon from "@mui/icons-material/Menu";
import Toolbar from "@mui/material/Toolbar";
import IconButton from "@mui/material/IconButton";
import ProfileIcon from "../Assets/Images/Common/ProfileIcon.svg";
// import { makeStyles } from '@material-ui/core/styles';
import cssClasses from "./MainPage.module.css";
import { Outlet } from "react-router-dom";
import Button from "../Subcomponents/Button";
import ArrowBack from "@mui/icons-material/ArrowBack";
import BottomMenu from "../Components/BottomMenu/BottomMenu";
import HelpDeskFab from "../Components/HelpDesk/HelpDeskFab";
import VjLogo from "../Assets/Images/SideMenu/VJ LOGO V1 1.svg";
import { supabase } from "../supabaseClient";
import { useDispatch, useSelector } from "react-redux";
import actions from "../Redux Store/actions";
import NotificationsNoneIcon from '@mui/icons-material/NotificationsNone';
import { Divider, Typography } from "@mui/material";
import { getCancellationData, getCancellationRepriceData, getChangePlanData, getChangeUnitData, getChangeUnitRepriceData, getTagApprovedData, getTagPendingData } from "../Services/Notifications";
import { dismissLoader, presentLoader } from "../Services/loader";
import { errorTost } from "../Services/Toast";
import TagPending from "../Assets/Images/Common/tagApproved.svg"
import ChangePlan from "../Assets/Images/Common/changePlan.svg"
import CancellationUnit from "../Assets/Images/Common/cancellationPending.svg"
import CancellationUnitReprice from "../Assets/Images/Common/cancellationReprice.svg"
import ChangeUnit from "../Assets/Images/Common/changeUnit.svg"
import ChangeUnitReprice from "../Assets/Images/Common/changeUnitReprice.svg"
import { Network } from "@capacitor/network";
import ReactTimeAgo from "react-time-ago";
import TimeAgo from "javascript-time-ago";
import en from "javascript-time-ago/locale/en.json";
const drawerWidth = "20%";



const HELPDESK_ROUTE = "/home/CRM-helpdesk";

function MainPage(props) {
  let loggedInUser = {};
  const dispatch = useDispatch();
  loggedInUser = useSelector((state) => state.Auth.user);
  let projectFlag = useSelector((state) => state.ProjectFlag.projectFlag);
  const { window1 } = props;
  const location = useLocation();
  const { eventId } = useParams();
  const navigate = useNavigate();
  const [mobileOpen, setMobileOpen] = useState(false);
  const [showSubMenuBurger, setShowSubMenuBurger] = useState(false);
  const [hideSideMenuForLiveInventory, setHideSideMenuForLiveInventory] = useState(false);
  const [state, setState] = React.useState({
    top: false,
    left: false,
    bottom: false,
    right: false,
  });
  const [tagPendingData, setTagPendingData] = useState([])
  const [tagApprovedData, setTagApprovedData] = useState([])
  const [changePlanData, setChangePlanData] = useState([])
  const [cancellationData, setCancellationData] = useState([])
  const [cancellationRepriceData, setCancellationRepriceData] = useState([])
  const [changeUnitData, setChangeUnitData] = useState([])
  const [changeUnitRepriceData, setChangeUnitRepriceData] = useState([]);
  const [sitevisitpendingdata, SetSitevisitpendingdata] = useState([]);
  const [assignedCallerNo, setAssignedCallerNo] = useState("");
  TimeAgo.setDefaultLocale(en.locale);
  TimeAgo.addLocale(en);
  const [disableReportButton, setDisableReportButton] = useState(location.pathname.includes('/home/APIDailyReports') ? true : false)

  const handleDrawerToggle = () => {
    setMobileOpen(!mobileOpen);
  };
  useEffect(() => {
    if (location.pathname.includes("/home/APIDailyReports")) {
      setDisableReportButton(true)
    }
    if (!location.pathname.includes("/home/APIDailyReports")) {
      setDisableReportButton(false)
    }

    console.log(location.pathname.includes("CreateLaunch"));
    if (location.pathname.includes("liveInventory") && eventId) {
      setHideSideMenuForLiveInventory(true);
    } else {
      setHideSideMenuForLiveInventory(false);

    }
    if (
      location.pathname.includes("/home/Event/Details") ||
      location.pathname.includes("/home/Event/ConfigureEvent") ||
      location.pathname.includes("/home/Sustenance/Details/") ||
      location.pathname.includes("/home/users/createUser")
    ) {
      setShowSubMenuBurger(true);
    } else {
      setShowSubMenuBurger(false);
      setMobileOpen(false);
    }
  }, [location]);

  // !!SnapShort on Roles Tables

  useEffect(() => {
    console.log({ loggedInUser });
    let updateListener = supabase
      .from(`Roles:roleId=eq.${loggedInUser.roleId.roleId}`)
      .on("UPDATE", (handleRecordUpdated) => {
        console.log('Role Updated');
        console.log(handleRecordUpdated);
        if (handleRecordUpdated.eventType === "UPDATE") {
          dispatch(
            actions.authLogin({
              ...loggedInUser,
              roleId: handleRecordUpdated.new,
            })
          );
          console.log({ loggedInUser });
        }
      })
      .subscribe((status) => {
        console.log("status: ", status);
      });
    return () => {
      if (updateListener) {
        supabase.removeSubscription(updateListener);
        updateListener = null;
      }
    };
  }, [])

  useEffect(() => {
    let tagPendingListner = null;
    let changePlanListner = null;
    let cancellationListener = null;
    let cancellationUpdateListner = null;
    let changeUnitListener = null;
    let changeUnitUpdateListner = null;

    if (loggedInUser?.roleId?.level === 1) {
      tagPendingListner = supabase
        .from(`CRM`)
        .on("INSERT", (payload) => {
          console.log("Change received!", payload);
          if (payload.eventType === "INSERT") {
            getTagPendingNotification()
          }
        })
        .subscribe((status) => {
          console.log("status: ", status);
        });

      changePlanListner = supabase
        .from(`CRM`)
        .on("UPDATE", (payload) => {
          console.log("Change received!", payload);
          if (payload.eventType === "UPDATE") {
            if (projectFlag?.projectFlag === true) {
              getChangePlanNotification()
            }

          }
        })
        .subscribe((status) => {
          console.log("status: ", status);
        });

      cancellationListener = supabase
        .from(`CancelUnitRequests`)
        .on("INSERT", (payload) => {
          if (payload.eventType === "INSERT") {
            getCancellationNotification()
          }
        })
        .subscribe((status) => {
          console.log("status: ", status);
        });

      cancellationUpdateListner = supabase
        .from(`CancelUnitRequests`)
        .on("UPDATE", (payload) => {
          if (
            payload.eventType === "UPDATE" &&
            payload.new.status === "Pending" &&
            payload.new.leadConfirmation === "Accepted"
          ) {
            getCancellationNotification()
          } else if (
            payload.eventType === "UPDATE" &&
            payload.new.status === "Accepted" &&
            payload.new.unitPriceAlreadyUpdated === false
          ) {
            getCancellationRepriceNotification()
          }
        })
        .subscribe((status) => {
          console.log("status: ", status);
        });

      changeUnitListener = supabase
        .from(`ChangeUnitRequests`)
        .on("INSERT", (payload) => {
          if (payload.eventType === "INSERT") {
            getChangeUnitNotification()
          }
        })
        .subscribe((status) => {
          console.log("status: ", status);
        });

      changeUnitUpdateListner = supabase
        .from(`ChangeUnitRequests`)
        .on("UPDATE", (payload) => {
          if (
            payload.eventType === "UPDATE" &&
            payload.new.status === "Pending"
          ) {
            getChangeUnitNotification();
          } else if (
            payload.eventType === "UPDATE" &&
            payload.new.status === "Accepted" &&
            payload.new.unitPriceAlreadyUpdated === false
          ) {
            getChangeUnitRepriceNotification()
          }
        })
        .subscribe((status) => {
          console.log("status: ", status);
        });
    } else {
      tagPendingListner = supabase
        .from(`CRM:requestPendingWithUserId=eq.${loggedInUser.userId}`)
        .on("INSERT", (payload) => {
          console.log("Change received!", payload);
          if (payload.eventType === "INSERT") {
            getTagPendingNotification()
          }
        })
        .subscribe((status) => {
          console.log("status: ", status);
        });

      changePlanListner = supabase
        .from(`CRM:requestPendingWithUserId=eq.${loggedInUser.userId}`)
        .on("UPDATE", (payload) => {
          console.log("Change received!", payload);
          if (payload.eventType === "UPDATE") {
            if (projectFlag?.projectFlag === true) {
              getChangePlanNotification()
            }
          }
        })
        .subscribe((status) => {
          console.log("status: ", status);
        });

      cancellationListener = supabase
        .from(
          `CancelUnitRequests:requestPendingWithUserId=eq.${loggedInUser.userId}`
        )
        .on("INSERT", (payload) => {
          if (payload.eventType === "INSERT") {
            getCancellationNotification()
          }
        })
        .subscribe((status) => {
          console.log("status: ", status);
        });

      cancellationUpdateListner = supabase
        .from(
          `CancelUnitRequests:requestPendingWithUserId=eq.${loggedInUser.userId}`
        )
        .on("UPDATE", (payload) => {
          if (
            payload.eventType === "UPDATE" &&
            payload.new.status === "Pending" &&
            payload.new.leadConfirmation === "Accepted"
          ) {
            getCancellationNotification()
          } else if (
            payload.eventType === "UPDATE" &&
            payload.new.status === "Accepted" &&
            payload.new.unitPriceAlreadyUpdated === false
          ) {
            getCancellationRepriceNotification()
          }
        })
        .subscribe((status) => {
          console.log("status: ", status);
        });

      changeUnitListener = supabase
        .from(
          `ChangeUnitRequests:requestPendingWithUserId=eq.${loggedInUser.userId}`
        )
        .on("INSERT", (payload) => {
          if (payload.eventType === "INSERT") {
            getChangeUnitNotification()
          }
        })
        .subscribe((status) => {
          console.log("status: ", status);
        });

      changeUnitUpdateListner = supabase
        .from(
          `ChangeUnitRequests:requestPendingWithUserId=eq.${loggedInUser.userId}`
        )
        .on("UPDATE", (payload) => {
          if (
            payload.eventType === "UPDATE" &&
            payload.new.status === "Pending"
          ) {
            getChangeUnitNotification()
          } else if (
            payload.eventType === "UPDATE" &&
            payload.new.status === "Accepted" &&
            payload.new.unitPriceAlreadyUpdated === false
          ) {
            getChangeUnitRepriceNotification()
          }
        })
        .subscribe((status) => {
          console.log("status: ", status);
        });
    }

    return () => {
      if (tagPendingListner?.subscription) {
        supabase.removeSubscription(tagPendingListner?.subscription);
        tagPendingListner = null;
      }
      if (cancellationListener?.subscription) {
        supabase.removeSubscription(cancellationListener?.subscription);
        cancellationListener = null;
      }
      if (changeUnitListener?.subscription) {
        supabase.removeSubscription(changeUnitListener?.subscription);
        changeUnitListener = null;
      }
      if (changeUnitUpdateListner) {
        supabase.removeSubscription(changeUnitUpdateListner);
        changeUnitUpdateListner = null;
      }
      Network.removeAllListeners();
    };
  }, []);

  useEffect(() => {
    getTagPendingNotification()
    // getTagApprovedNotification()
    getChangePlanNotification()
    getCancellationNotification()
    getCancellationRepriceNotification()
    getChangeUnitNotification()
    getChangeUnitRepriceNotification()
  }, [state])
  const drawer = (
    <div style={{ height: "100%", width: "100%" }}>
      <SideMenu
        props={(v) => {
          setMobileOpen(v);
        }}
      />
    </div>
  );
  const container =
    window1 !== undefined ? () => window().document.body : undefined;

  function goBack() {
    setDisableReportButton(false)
    navigate(-1);
  }

  const getTagPendingNotification = () => {
    if (loggedInUser.roleId.level === 1) {
      presentLoader()
      getTagPendingData(false).then(resp => {
        setTagPendingData({ tab: "tag-pending", count: resp?.count, data: resp?.data })
        dismissLoader()
      }).catch(err => {
        errorTost(err.message)
        dismissLoader()
      })
    } else if (loggedInUser?.roleId?.accessibleTabs?.["All Allotments"]?.CRM?.['Tag Pending']?.isAccessible) {
      presentLoader()
      getTagPendingData(false, loggedInUser.userId).then(resp => {
        setTagPendingData({ tab: "tag-pending", count: resp?.count, data: resp?.data })
        dismissLoader()
      }).catch(err => {
        errorTost(err.message)
        dismissLoader()
      })
    }
  }

  const getTagApprovedNotification = () => {
    if (loggedInUser.roleId.level === 1) {
      presentLoader()
      getTagApprovedData(false, true, false, false).then(resp => {
        setTagApprovedData({ count: resp?.count, data: resp?.data })
        dismissLoader()
      }).catch(err => {
        errorTost(err.message)
        dismissLoader()
      })
    } else if (loggedInUser?.roleId?.accessibleTabs?.["All Allotments"]?.CRM?.['Tag Approved']?.isAccessible) {
      presentLoader()
      getTagApprovedData(true, true, false, false, loggedInUser.userId).then(resp => {
        setTagApprovedData({ count: resp?.count, data: resp?.data })
        dismissLoader()
      }).catch(err => {
        errorTost(err.message)
        dismissLoader()
      })
    }
  }

  const getChangePlanNotification = () => {
    if (loggedInUser.roleId.level === 1) {
      presentLoader()
      getChangePlanData(true, true, false, false).then(resp => {
        setChangePlanData({ tab: "change-plan", count: resp?.count, data: resp?.data })
        dismissLoader()
      }).catch(err => {
        errorTost(err.message)
        dismissLoader()
      })
    } else if (loggedInUser?.roleId?.accessibleTabs?.["All Allotments"]?.CRM?.['Changed plan']?.isAccessible) {
      presentLoader()
      getChangePlanData(true, true, false, false, loggedInUser.userId).then(resp => {
        setChangePlanData({ tab: "change-plan", count: resp?.count, data: resp?.data })
        dismissLoader()
      }).catch(err => {
        errorTost(err.message)
        dismissLoader()
      })
    }
  }

  const getCancellationNotification = () => {
    if (loggedInUser.roleId.level === 1) {
      presentLoader()
      getCancellationData("Pending", "Accepted",).then(resp => {
        setCancellationData({ tab: "cancellation", count: resp?.count, data: resp?.data })
        dismissLoader()
      }).catch(err => {
        errorTost(err.message)
        dismissLoader()
      })
    } else if (loggedInUser?.roleId?.accessibleTabs?.["All Allotments"]) {
      presentLoader()
      getCancellationData("Pending", "Accepted", loggedInUser.userId).then(resp => {
        setCancellationData({ tab: "cancellation", count: resp?.count, data: resp?.data })
        dismissLoader()
      }).catch(err => {
        errorTost(err.message)
        dismissLoader()
      })
    }
  }

  const getCancellationRepriceNotification = () => {
    if (loggedInUser.roleId.level === 1) {
      presentLoader()
      getCancellationRepriceData("Accepted", false,).then(resp => {
        setCancellationRepriceData({ tab: "cancellation-reprice", count: resp?.count, data: resp?.data })
        dismissLoader()
      }).catch(err => {
        errorTost(err.message)
        dismissLoader()
      })
    } else if (loggedInUser?.roleId?.accessibleTabs?.["All Allotments"]?.["Reprice Unit"]
      ?.isAccessible) {
      presentLoader()
      getCancellationRepriceData("Accepted", false, loggedInUser.userId).then(resp => {
        setCancellationRepriceData({ tab: "cancellation-reprice", count: resp?.count, data: resp?.data })
        dismissLoader()
      }).catch(err => {
        errorTost(err.message)
        dismissLoader()
      })
    }
  }

  const getChangeUnitNotification = () => {
    if (loggedInUser.roleId.level === 1) {
      presentLoader()
      getChangeUnitData("Pending",).then(resp => {
        setChangeUnitData({ tab: "change-unit", count: resp?.count, data: resp?.data })
        dismissLoader()
      }).catch(err => {
        errorTost(err.message)
        dismissLoader()
      })
    } else if (loggedInUser?.roleId?.accessibleTabs?.["All Allotments"]) {
      presentLoader()
      getChangeUnitData("Pending", loggedInUser.userId).then(resp => {
        setChangeUnitData({ tab: "change-unit", count: resp?.count, data: resp?.data })
        dismissLoader()
      }).catch(err => {
        errorTost(err.message)
        dismissLoader()
      })
    }
  }

  const getChangeUnitRepriceNotification = () => {
    if (loggedInUser.roleId.level === 1) {
      presentLoader()
      getChangeUnitRepriceData("Accepted", false).then(resp => {
        setChangeUnitRepriceData({ tab: "change-unit-reprice", count: resp?.count, data: resp?.data })
        dismissLoader()
      }).catch(err => {
        errorTost(err.message)
        dismissLoader()
      })
    } else if (loggedInUser?.roleId?.accessibleTabs?.["All Allotments"]?.["Reprice Unit"]
      ?.isAccessible) {
      presentLoader()
      getChangeUnitRepriceData("Pending", false, loggedInUser.userId).then(resp => {
        setChangeUnitRepriceData({ tab: "change-unit-reprice", count: resp?.count, data: resp?.data })
        dismissLoader()
      }).catch(err => {
        errorTost(err.message)
        dismissLoader()
      })
    }
  }
  const toggleDrawer = (anchor, open) => (event) => {
    if (event.type === 'keydown' && (event.key === 'Tab' || event.key === 'Shift')) {
      return;
    }

    setState({ ...state, [anchor]: open });
  };

  const handleRoute = index => {
    if (index === "cancellation") {
      navigate('/home/AllAllotments')
      sessionStorage.setItem("tab", "cancellation")
    } else if (index === "cancellation-reprice") {
      navigate('/home/AllAllotments')
      sessionStorage.setItem("tab", "cancellation-reprice")
    } else if (index === "tag-pending") {
      navigate('/home/AllAllotments')
      sessionStorage.setItem("tab", "tag-pending")
    } else if (index === "change-plan") {
      navigate('/home/AllAllotments')
      sessionStorage.setItem("tab", "change-plan")
    } else if (index === "change-unit") {
      navigate('/home/AllAllotments')
      sessionStorage.setItem("tab", "change-unit")
    } else {
      navigate('/home/AllAllotments')
      sessionStorage.setItem("tab", "change-unit-reprice")
    }
  }

  const list = (anchor) => (
    <Box
      className={cssClasses.notificationSideBar}
      sx={{
        width: 400,
        background: "#ffebf7",
        padding: "5rem",
        display: "flex",
        flexDirection: "column",
        gap: "2rem",
        height: "100%"
      }}
      role="presentation"
      onClick={toggleDrawer(anchor, false)}
      onKeyDown={toggleDrawer(anchor, false)}
    >
      <span style={{ fontSize: "1.6rem", fontFamily: "inter-semibold" }}>
        My Task List
      </span>
      <div style={{ display: "flex", flexDirection: "column", gap: "1rem" }}>
        {/* <span style={{ fontSize: "1.4rem", fontFamily: "inter-semibold" }}>
          Task
        </span> */}
        {[
          loggedInUser?.roleId?.accessibleTabs?.["All Allotments"]?.CRM?.['Tag Pending']?.isAccessible ? tagPendingData : null,
          loggedInUser?.roleId?.accessibleTabs?.["All Allotments"]?.CRM?.['Changed plan']?.isAccessible ? changePlanData : null,
          loggedInUser?.roleId?.accessibleTabs?.["All Allotments"] ? cancellationData : null,
          loggedInUser?.roleId?.accessibleTabs?.["All Allotments"]?.["Reprice Unit"]?.isAccessible ? cancellationRepriceData : null,
          loggedInUser?.roleId?.accessibleTabs?.["All Allotments"] ? changeUnitData : null,
          loggedInUser?.roleId?.accessibleTabs?.["All Allotments"]?.["Reprice Unit"]?.isAccessible ? changeUnitRepriceData : null,

        ]?.filter(val => val !== null).map((val, index) => {
          return (
            <div style={{ display: "flex", flexDirection: "column", gap: "1rem", cursor: "pointer" }} onClick={() => { handleRoute(val?.tab) }}>
              <div style={{ display: 'flex', alignItems: "center", gap: "2rem" }}>
                <div
                  style={{
                    display: "flex",
                    background: "rgba(226, 242, 255, 1)",
                    width: "35px",
                    height: "35px",
                    alignItems: "center",
                    justifyContent: "center",
                    borderRadius: "20px",
                  }}
                >
                  <img
                    src={
                      val?.tab === "tag-pending"
                        ? TagPending
                        : val?.tab === "change-plan"
                          ? ChangePlan
                          : val?.tab === "cancellation"
                            ? CancellationUnit
                            : val?.tab === "cancellation-reprice"
                              ? CancellationUnitReprice
                              : val?.tab === "change-unit"
                                ? ChangeUnit
                                : ChangeUnitReprice
                    }
                    alt="img"
                    style={{ borderRadius: "20px", width: "20px" }}
                  />
                </div>
                <div style={{ display: "flex", flexDirection: "column" }}>
                  <span style={{ fontSize: "12px" }}>
                    <span
                      style={{
                        color: "rgba(255, 118, 40, 1)",
                        fontFamily: "inter-semibold",
                        marginRight: "3px",
                      }}
                    >
                      {val?.count}
                    </span>
                    {val?.tab === "tag-pending"
                      ? "CRM tag approval pending"
                      : val?.tab === "change-plan"
                        ? "CRM changed plan approval pending"
                        : val?.tab === "cancellation"
                          ? "Cancellation pending"
                          : val?.tab === "cancellation-reprice"
                            ? "Reprice for cancellation pending"
                            : val?.tab === "change-unit"
                              ? "Change unit request pending"
                              : "Reprice for change unit pending"}
                  </span>
                  <span
                    style={{ color: "rgba(28, 28, 28, 0.4)", fontSize: "12px" }}
                  >
                    {val?.data?.length > 0 ? (
                      <ReactTimeAgo
                        style={{ fontSize: "12px" }}
                        date={val?.data[0]?.last_updated_at}

                      />
                    ) : "-"}
                  </span>
                </div>
              </div>
              {index !== [
                loggedInUser?.roleId?.accessibleTabs?.["All Allotments"]?.CRM?.['Tag Pending']?.isAccessible ? tagPendingData : null,
                loggedInUser?.roleId?.accessibleTabs?.["All Allotments"]?.CRM?.['Changed plan']?.isAccessible ? changePlanData : null,
                loggedInUser?.roleId?.accessibleTabs?.["All Allotments"] ? cancellationData : null,
                loggedInUser?.roleId?.accessibleTabs?.["All Allotments"]?.["Reprice Unit"]?.isAccessible ? cancellationRepriceData : null,
                loggedInUser?.roleId?.accessibleTabs?.["All Allotments"] ? changeUnitData : null,
                loggedInUser?.roleId?.accessibleTabs?.["All Allotments"]?.["Reprice Unit"]?.isAccessible ? changeUnitRepriceData : null,
              ]?.filter(val => val !== null)?.length - 1 && <span style={{ paddingLeft: "2rem", fontSize: "1.7rem", color: "rgba(28, 28, 28, 0.1)" }}>|</span>}
            </div>
          );
        })}
      </div>
    </Box>
  );


  const date = new Date();

  const months = [
    'Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun',
    'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'
  ];

  const day = date.getDate();
  const month = months[date.getMonth()];
  const year = date.getFullYear();
  // const amOrPm = (date.getHours() === 18 && date.getMinutes() >= 30) ? 'PM' : 'AM'
  const amOrPm = () => {
    if (date.getHours() === 18 && date.getMinutes() >= 30) {
      return 'PM'
    } else if (date.getHours() === 6 && date.getMinutes() >= 30) {
      return 'AM'
    } else if (date.getHours() < 18 && date.getHours() > 6) {
      return 'AM'
    } else if (date.getHours() > 18) {
      return 'PM'
    } else {
      return 'AM'
    }
  }


  const formattedDate = `${day} ${month}, ${year} | 6:30 ${amOrPm()}`;

  // get User From Local Storage 
  useEffect(() => {
    const userFromLocalStorage = JSON.parse(localStorage.getItem("user"));
    if (userFromLocalStorage) {
      setAssignedCallerNo(userFromLocalStorage?.assignedCallerDid || "");
    }
  }, []);







  return (
    <Box
      sx={{ display: "flex" }}
      style={{
        height: "100%",
        // flexDirection: window.innerWidth <= 820 ? "column" : "",
      }}
    >
      {(window.innerWidth > 820) && (
        <>
          <CssBaseline />
          <Toolbar
            className={cssClasses.wrapperMenu}
            sx={{
              width: { sm: `calc(100% - ${drawerWidth}px)` },
              ml: { sm: `${drawerWidth}px` },
              alignItems: "flexStart !important",
              // position:'fixed'
            }}
          >
            <IconButton
              color="inherit"
              aria-label="open drawer"
              edge="start"
              onClick={handleDrawerToggle}

            >
              <MenuIcon />
            </IconButton>
          </Toolbar>
        </>
      )}
      {!hideSideMenuForLiveInventory && (

        <Box
          component="nav"
          sx={{ width: { sm: drawerWidth }, flexShrink: { sm: 0 } }}
          aria-label="mailbox folders"
          style={{ height: "100%" }}
        >
          {/* The implementation can be swapped with js to avoid SEO duplication of links. */}
          <Drawer
            container={container}
            variant="temporary"
            open={mobileOpen}
            onClose={handleDrawerToggle}
            ModalProps={{
              keepMounted: true, // Better open performance on mobile.
            }}
            sx={{
              display: { xs: "block", sm: "none" },
              "& .MuiDrawer-paper": {
                boxSizing: "border-box",
                width: window.innerWidth > 820 ? drawerWidth : "50%",
              },
            }}
          >
            {drawer}
          </Drawer>
          <Drawer
            variant="permanent"
            sx={{
              display: { xs: "none", sm: "block" },
              "& .MuiDrawer-paper": {
                boxSizing: "border-box",
                width: drawerWidth,
              },
            }}
            open
          >
            {drawer}
          </Drawer>
        </Box>
      )}
      <Box
        display={"flex"}
        flexDirection={"column"}
        // component="main"
        sx={{
          flexGrow: 1,
          // minWidth: 0 lets this row-flex child actually shrink to the
          // space left by the sidebar instead of being held to its content's
          // natural width (the classic flex min-width:auto gotcha) — without
          // it, a wide descendant (e.g. the header buttons) could force this
          // whole column, and the page, wider than the viewport on mobile.
          // overflowX: 'clip' (mobile only) is a hard backstop for anything
          // that still doesn't fit; 'clip' never turns this into a scroll
          // container, so it can't affect any sticky content further down.
          minWidth: 0,
          overflowX: window.innerWidth <= 820 ? "clip" : "visible",
          width: {
            sm: `calc(100% - ${drawerWidth})`,
            height: "100%",
            padding: 0,
            width: "80%",
          },
        }}
      >
        {/* To show burger menu in mobile app with VjLogo */}
        {window.innerWidth < 820 && showSubMenuBurger && (
          <div style={{
            display: 'flex'
          }}>
            <Toolbar
              className={cssClasses.wrapperMenu}
              sx={{
                width: { sm: `calc(100% - ${drawerWidth}px)` },
                ml: { sm: `${drawerWidth}px` },
                alignItems: "flexStart !important",
                // position:'fixed'
              }}
            >
              <IconButton
                color="inherit"
                aria-label="open drawer"
                edge="start"
                onClick={handleDrawerToggle}
              >
                <MenuIcon />
              </IconButton>
            </Toolbar>
            <span><img src={VjLogo} style={{ width: '19rem' }}></img></span>
          </div>
        )}
        {!hideSideMenuForLiveInventory && (
          <Box className={cssClasses.headerDiv}>
            {window.innerWidth > 820 && <Box width={"fit-Content"} mt={0.6}>
              <Button
                style={{
                  fontSize: "1.6rem",
                  lineHeight: "2.4rem",
                  color: "#000000",
                  backgroundColor: "#FFFFFF",
                  border: "none",
                  boxShadow: "none",
                }}
                padding={"0"}
                btnIcon={
                  <ArrowBack
                    style={{ width: "2rem", height: "2rem", color: "#000000" }}
                  />
                }
                iconPosition={"left"}
                btnName={"Back"}
                clicked={() => goBack()}
              />
            </Box>}
            <div className={cssClasses.iconWrapper}>
              <Box marginLeft={"auto"} style={{ display: "flex", gap: window.innerWidth <= 820 ? "0.5rem" : "1rem" }}>
                {/* Help Desk - shown only for CRM users, left of API Report's */}
                {loggedInUser?.isCrmUser && (
                  <Box>
                    <Button
                      btnName={"Raise HelpDesk Ticket"}
                      padding={window.innerWidth <= 820 ? "0.6rem 1rem" : undefined}
                      style={{
                        color: "#fdffff",
                        boxShadow: "none",
                        backgroundColor: "#1570ef",
                        fontSize: window.innerWidth <= 820 ? "1.3rem" : undefined,
                      }}
                      clicked={() => navigate(HELPDESK_ROUTE)}
                    />
                  </Box>
                )}

                {loggedInUser?.roleId?.accessibleTabs?.["API Reports"]?.isAccessible && <Box>
                  <Button
                    // On mobile the bold title sits above the smaller date/time
                    // instead of one long inline string — a much narrower button
                    // that actually fits next to "Raise HelpDesk Ticket" on one
                    // line, instead of wrapping onto its own row. Desktop keeps
                    // the original single-line text untouched.
                    btnName={
                      window.innerWidth <= 820 ? (
                        <span style={{ display: "flex", flexDirection: "column", lineHeight: 1.25 }}>
                          <span style={{ fontWeight: 700 }}>API Report's</span>
                          <span style={{ fontSize: "1.1rem", fontWeight: 400 }}>{formattedDate}</span>
                        </span>
                      ) : (
                        `API Report's (${formattedDate})`
                      )
                    }
                    padding={window.innerWidth <= 820 ? "0.5rem 1rem" : undefined}
                    style={{ color: disableReportButton ? "black" : "#fdffff", boxShadow: "none", backgroundColor: disableReportButton ? "lightGrey" : "#1570ef", fontSize: window.innerWidth <= 820 ? "1.3rem" : undefined, lineHeight: window.innerWidth <= 820 ? "1.5rem" : undefined }} clicked={() => {
                    if (location.pathname.includes('/home/APIDailyReports')) {
                      setDisableReportButton(true)
                    } else {
                      setDisableReportButton(false)
                    }
                    navigate("/home/APIDailyReports")
                  }} />
                </Box>}
                {/* <Box marginLeft={"auto"} onClick={() => navigate('/home/Profile')}>

                <img src={ProfileIcon} alt="Profile" style={{ cursor: "pointer" }} />
              </Box> */}
              </Box>
              {/* Shoe Here Assisgned Caller DID */}
              {assignedCallerNo && (
                <Box
                  sx={{
                    ml: 1.5,
                    display: "inline-flex",
                    alignItems: "center",
                    justifyContent: "center",
                    px: 1.5,
                    py: 0.5,
                    backgroundColor: "rgba(21, 112, 239, 0.1)",
                    borderRadius: "999px",
                  }}
                >
                  <Typography
                    sx={{
                      color: "#ef15e0",
                      fontSize: "12px",
                      fontWeight: 500,
                    }}
                  >
                  Virtual No.:  {assignedCallerNo}
                  </Typography>
                </Box>
              )}
              <Box onClick={toggleDrawer("right", true)} marginLeft={"auto"} sx={{ display: "flex", justifyContent: "center", width: "32px", height: "32px", display: "flex", alignItems: "center", background: "rgb(21, 112, 239)", borderRadius: "20px" }}>
                <NotificationsNoneIcon sx={{ transform: "scale(1.6)", color: "white" }} />
              </Box>
              {window.innerWidth > 820 &&
                <Box marginLeft={"auto"} onClick={() => navigate('/home/Profile')}>
                  <img src={ProfileIcon} alt="Profile" style={{ cursor: "pointer" }} />
                </Box>
              }
            </div>
          </Box>
        )}
        {/* )} */}
        <Box
          sx={{ height: "95%", overflowY: "auto" }}
          style={{
            padding: window.innerWidth <= 820 ? "0rem" : "0rem",
          }}
        >
          <Outlet />
        </Box>
        <Drawer
          anchor={"right"}
          open={state["right"]}
          onClose={toggleDrawer("right", false)}
        >
          {list("right")}
        </Drawer>
        {/* Mobile bottom menu */}
        {(window.innerWidth <= 820) && (
          <BottomMenu
            props={(v) => {
              setMobileOpen(v);
            }}
          />
        )}
      </Box>
      {/* Floating Help Desk button - visible on every CRM page */}
      {/* <HelpDeskFab /> */}
    </Box>
  );
}
export default MainPage;
